
import { IconButton, Tooltip, Stack } from "@mui/material";
export const ReactionBar = ({ onReact }) => {
    const emojiList = ["👍", "❤️", "😆", "😮"];

    return (
        <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            className="mt-1"
            sx={{
                border: "1px solid #e0e0e0",
                padding: "2px 4px",
                backgroundColor: "white",
                borderRadius: "6px",
                "&:hover": {
                    backgroundColor: "#f0f0f0",
                },
            }}
        >
            {emojiList.map((emoji) => (
                <Tooltip key={emoji} title={`React with ${emoji}`}>
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => onReact(emoji)}
                        className="transition-transform hover:scale-110"
                        sx={{
                            "&:hover": {
                                backgroundColor: "#f0f0f0",
                            },
                        }}
                    >
                        <span style={{ fontSize: "16px" }}>{emoji}</span>
                    </IconButton>
                </Tooltip>
            ))}
        </Stack>
    );
};

